<div *ngIf="oc?.length && ocMerged?.length" class="outage">

  <div class="flex-it col">

    <div #swiper
         [index]="swiperIdx"
         [swiper]="swiperConfig"
         class="swiper-container">

      <div class="swiper-wrapper">

        <ng-container *ngFor="let asset of oc">

          <div class="swiper-slide slide-noswiping">
            <app-outage-chart [asset]="asset.assetLabel"
                              [country]="country.label"
                              [ocData]="ocMerged">
            </app-outage-chart>
          </div>

        </ng-container>

      </div>

    </div>

    <app-chart-pag (idx)="onSwipe($event)" [pages]="country.assetsSelected"></app-chart-pag>

  </div>

  <div *ngIf="withTable" class="outage__table">

    <div #flexdiv class="flextable-by-row">

      <!-- FIRST COL WITH TS -->
      <div class="flextable-by-row__row header vert-sticky">
        <div class="row-header hor-sticky"></div>
        <ng-container *ngFor="let curOc of oc;">
          <div class="separator">{{curOc.assetLabel}}</div>
          <div class="greyed-out" matTooltip="cumulative outage cost">++</div>
          <div class="greyed-out" matTooltip="cumulative p&l">p&l</div>
        </ng-container>
      </div>

      <!-- THEN ACTUAL ASSETS -->
      <virtual-scroller (vsUpdate)="vsItems = $event"
                        [items]="ocMerged"
                        [parentScroll]="flexdiv"
                        [stripedTable]="true"
                        style="height: calc(100% - 40px)">

        <div *ngFor="let curOcMerged of vsItems;" class="flextable-by-row__row">

          <div class="row-header hor-sticky">{{curOcMerged.ts | date:'dd/MM HH:mm'}}</div>

          <ng-container *ngFor="let curOc of oc;">
            <div class="separator">
              {{curOcMerged[curOc.assetLabel + OC_SUFFIX] | number:'0.2-2'}}
            </div>
            <div>
              {{curOcMerged[curOc.assetLabel + OC_SUFFIX + CUM_SUFFIX] | number:'0.2-2'}}
            </div>
            <div>
              {{curOcMerged[curOc.assetLabel + PNL_SUFFIX + CUM_SUFFIX] | number:'0.2-2'}}
            </div>
          </ng-container>

        </div>

      </virtual-scroller>

    </div>

  </div>

</div>

